import React from "react";
import { A, fonts, tokens } from "../lib/theme";

// Last-resort guard against a blank white page. If any descendant throws during render
// (e.g. an object accidentally rendered as a React child — error #31), React would
// otherwise unmount the entire tree and leave a blank screen. This boundary catches that
// and shows a recoverable fallback instead. Wrap the whole app with it in index.js.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Surface details in the console for debugging; the UI stays friendly.
    console.error("ErrorBoundary caught a render error:", error, info?.componentStack);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        style={{
          minHeight: "100vh",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: A.bg,
          fontFamily: fonts.body,
          padding: "1.5rem",
        }}
      >
        <div
          style={{
            backgroundColor: A.card,
            border: tokens.border.thin,
            borderRadius: tokens.radius.card,
            boxShadow: tokens.shadow.card,
            padding: "2rem",
            maxWidth: "420px",
            width: "100%",
            textAlign: "center",
          }}
        >
          <div
            style={{
              fontFamily: fonts.display,
              fontSize: "1.25rem",
              fontWeight: 700,
              color: A.dark,
              marginBottom: "0.5rem",
            }}
          >
            Something went wrong
          </div>
          <div style={{ fontSize: "0.9rem", color: A.muted, lineHeight: 1.5, marginBottom: "1.5rem" }}>
            We hit an unexpected error. Reloading the page usually fixes it. If it keeps
            happening, please contact support.
          </div>
          <button
            type="button"
            onClick={this.handleReload}
            style={{
              backgroundColor: A.crimson,
              color: A.card,
              border: "none",
              borderRadius: tokens.radius.button,
              padding: tokens.padding.btnPrimary,
              fontSize: "0.9rem",
              fontWeight: 700,
              cursor: "pointer",
              fontFamily: fonts.body,
            }}
          >
            Reload page
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
